<h2 mat-dialog-title>Password Requires Attention!</h2>

<mat-dialog-content fxLayout="column">
    <div class="error">{{expirationMessage}}</div>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button fxLayout="column" [mat-dialog-close]="false" telemetry="Submission-Later">
        Later
    </button>

    <button mat-button fxLayout="column" [mat-dialog-close]="true" telemetry="Submission-ChangePassword">
        Change Password
    </button>
</mat-dialog-actions>
